import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { isTutorCallSupportedClient } from '@/utils/tutorCallClient'

/** 桌面 UA + /chat?rtc=1 时开启师生通话；rtc=0 或无参数关闭 */
export default function useTutorCallDesktop(): boolean {
  const { pathname, search } = useLocation()
  return useMemo(() => isTutorCallSupportedClient(undefined, { pathname, search }), [pathname, search])
}
